import React from 'react'
import Header from '../../components/Header'
import Hero from '../../components/Hero'
import Poems from '../../components/Poems'
import About from '../../components/About'
import Contact from '../../components/Contact'
import Footer from '../../components/Footer'
import GoogleAd from '../../components/GoogleAd'



function Homepage() {
  return (
    <div>
      <Header />
      <Hero />
       <GoogleAd
        adClient="ca-pub-7602772160441740" 
        adSlot="1474149218" 
        adFormat="auto"
      />
      <Poems />
      <About />
      <Contact />
      <Footer />
      <GoogleAd
        adClient="ca-pub-7602772160441740" 
        adSlot="4950978342" 
        adFormat="auto"
      />
    </div>
  )
}

export default Homepage
